import {
    ConcentrationOrigin, DataQuality, PolygonType,
    QualityCriterionType, RemovalReason, ScreeningFlag,
    ScreeningLogInfo, ScreeningStatus } from '../enums';
import { LocationInfo } from '../common';
import { Industry } from './industry';
import { Activity } from './activity';
import { ScreeningStandardparameters } from './screening-standard-parameters';

export class PreliminaryScreeningResultDetailView {
    public id: string;
    public createdAt: Date;
    public status: ScreeningStatus;

    public location: LocationInfo;

    public industry: Industry; // For V1 polygons
    public activity: Activity; // For V1 polygons
    public compoundName: string;
    public compoundCasNr: string;
    public qualityCriterion: number;
    public qualityCriterionType: QualityCriterionType;
    public worstCaseConcentration: number;
    public concentrationOrigin: ConcentrationOrigin;
    public coverThickness: number;
    public dataQuality: DataQuality;

    public concentrationDownstream: number;
    public removed: boolean;
    public removalReason: RemovalReason;
    public logInfo: Array<ScreeningLogInfo>;

    public concTopTables: number;
    public conc100mGrundRisk: number;

    public factor: number;
    public flag: ScreeningFlag;
    public polygonArea: number;
    public polygonType: PolygonType;
    public standardParameters: ScreeningStandardparameters;

    public constructor(init: Partial<PreliminaryScreeningResultDetailView>) {
        Object.assign(this, init);
    }
}
